import iconTemplate from '~/components/icons/IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Date-Picker--Streamline-Flex"
    >
        <desc>{'Date Picker Streamline Icon: https://streamlinehq.com'}</desc>
        <g id="date-picker--date-day-month-year-input-pick-select-internet-form-fill">
            <path
                id="Intersect"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0.624499 8.70177C0.810427 10.1247 2.02783 11.2193 3.45848 11.3309 4.60947 11.4208 5.79273 11.5 7 11.5c1.20727 0 2.39053 -0.0792 3.5415 -0.1691 1.4307 -0.1116 2.6481 -1.2062 2.834 -2.62913C13.4484 8.14368 13.5 7.5758 13.5 7c0 -0.5758 -0.0516 -1.14368 -0.1245 -1.70177 -0.1859 -1.42291 -1.4033 -2.51749 -2.834 -2.62915C9.39053 2.57925 8.20727 2.5 7 2.5c-1.20727 0 -2.39053 0.07925 -3.54152 0.16908C2.02783 2.78074 0.810426 3.87532 0.624499 5.29823 0.551575 5.85632 0.5 6.4242 0.5 7c0 0.5758 0.051576 1.14368 0.124499 1.70177Z"
                strokeWidth={1}
            />
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m5.59056 5.62244 -0.92308 2.76923"
                strokeWidth={1}
            />
            <path
                id="Vector_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m9.3325 5.62244 -0.92308 2.76923"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
